<template>
  <div :class="{'hidden':hidden}" class="pagination-container">
    <el-pagination
      :background="background"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :layout="layout"
      :page-sizes="pageSizes"
      :total="total"
      v-bind="$attrs"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { scrollTo } from '@/utils/scroll-to'

export default {
  name: 'Pagination',
  props: {
    total: {
      required: true,
      type: Number
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 20
    },
    pageSizes: {
      type: Array,
      default() {
        return [ 10, 20, 30, 50, 100, 200]
      }
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: true
    },
    hidden: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.page
      },
      set(val) {
        this.$emit('update:page', val)
      }
    },
    pageSize: {
      get() {
        return this.limit
      },
      set(val) {
        this.$emit('update:limit', val)
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      this.$emit('pagination', { page: this.currentPage, limit: val })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    },
    handleCurrentChange(val) {
      this.$emit('pagination', { page: val, limit: this.pageSize })
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    }
  }
}
</script>

<style scoped>
.pagination-container {
  background: #fff;
  padding: 32px 16px;
}
.pagination-container.hidden {
  display: none;
}

/* 分页条：整体一行、水平居中、垂直居中 */
.pagination-container >>> .el-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  row-gap: 8px;
}

/* 关键：页面里常有 .el-input__inner { height: 40px !important } 之类全局规则，
   会把「每页条数」下拉框和「前往」输入框撑高，导致和其它控件不在同一行，
   这里用 !important 把分页内部的输入框统一回 32px */
.pagination-container >>> .el-pagination .el-input__inner {
  height: 32px !important;
  line-height: 32px !important;
  padding: 0 8px;
}

.pagination-container >>> .el-pagination .el-select,
.pagination-container >>> .el-pagination .el-pagination__jump,
.pagination-container >>> .el-pagination .el-select .el-input,
.pagination-container >>> .el-pagination .el-pagination__jump .el-input {
  vertical-align: middle;
}

.pagination-container >>> .el-pagination .el-select .el-input__suffix,
.pagination-container >>> .el-pagination .el-pagination__jump .el-input__suffix {
  line-height: 32px;
}

/* 页码与前后翻页按钮同高，避免大小不一 */
.pagination-container >>> .el-pagination button,
.pagination-container >>> .el-pagination .el-pager li {
  height: 32px !important;
  min-width: 32px !important;
  line-height: 32px !important;
}

/* 文字项与控件同高，基线一致 */
.pagination-container >>> .el-pagination__total,
.pagination-container >>> .el-pagination__sizes,
.pagination-container >>> .el-pagination__jump {
  height: 32px;
  line-height: 32px;
}
</style>
